
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riplay",
      function () {
        return require("private-next-pages/riplay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riplay"])
      });
    }
  